import { render, staticRenderFns } from "./TrafficLights.vue?vue&type=template&id=739c96c8&scoped=true"
import script from "./TrafficLights.vue?vue&type=script&lang=js"
export * from "./TrafficLights.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739c96c8",
  null
  
)

export default component.exports